"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWSClsErr = exports.WebSocketCloseError = exports.WebSocketErrorType = exports.WebSocketState = void 0;
/**
 * WebSocket 连接状态枚举
 */
var WebSocketState;
(function (WebSocketState) {
    /**
     * 尚未初始化
     */
    WebSocketState[WebSocketState["NOTINITIALIZED"] = -1] = "NOTINITIALIZED";
    /**
     * 正在链接中
     */
    WebSocketState[WebSocketState["CONNECTING"] = 0] = "CONNECTING";
    /**
     * 已经链接并且可以通讯
     */
    WebSocketState[WebSocketState["OPEN"] = 1] = "OPEN";
    /**
     * 连接正在关闭
     */
    WebSocketState[WebSocketState["CLOSING"] = 2] = "CLOSING";
    /**
     * 连接已关闭或者没有链接成功
     */
    WebSocketState[WebSocketState["CLOSED"] = 3] = "CLOSED";
})(WebSocketState = exports.WebSocketState || (exports.WebSocketState = {}));
var WebSocketErrorType;
(function (WebSocketErrorType) {
    WebSocketErrorType["Error"] = "Error";
    WebSocketErrorType["Close"] = "Close";
    WebSocketErrorType["MicroAuth"] = "MicroAuth";
    WebSocketErrorType["DuplicateConnect"] = "DuplicateConnect";
    WebSocketErrorType["IllegalURL"] = "IllegalURL";
    WebSocketErrorType["Unknown"] = "Unknown";
    WebSocketErrorType["IllegalArgs"] = "IllegalArgs";
})(WebSocketErrorType = exports.WebSocketErrorType || (exports.WebSocketErrorType = {}));
/**
 * WebSocket 异常关闭枚举：https://developer.mozilla.org/zh-CN/docs/Web/API/CloseEvent。
 */
var WebSocketCloseError;
(function (WebSocketCloseError) {
    /**
     * 终端离开, 可能因为服务端错误, 也可能因为浏览器正从打开连接的页面跳转离开。
     */
    WebSocketCloseError["Err_1001"] = "CLOSE_GOING_AWAY";
    /**
     * 由于协议错误而中断连接。
     */
    WebSocketCloseError["Err_1002"] = "CLOSE_PROTOCOL_ERROR";
    /**
     * 由于接收到不允许的数据类型而断开连接 (如仅接收文本数据的终端接收到了二进制数据)。
     */
    WebSocketCloseError["Err_1003"] = "CLOSE_UNSUPPORTED";
    /**
     * 安全因素或WebSocket连接次数达到上限。
     */
    WebSocketCloseError["Err_1006"] = "CLOSE_ABNORMAL";
    /**
     * 由于收到了格式不符的数据而断开连接 (如文本消息中包含了非 UTF-8 数据)。
     */
    WebSocketCloseError["Err_1007"] = "Unsupported Data";
    /**
     * 由于收到不符合约定的数据而断开连接。
     */
    WebSocketCloseError["Err_1008"] = "Policy Violation";
    /**
     * 由于收到过大的数据帧而断开连接。
     */
    WebSocketCloseError["Err_1009"] = "CLOSE_TOO_LARGE";
    /**
     * 未知错误。
     */
    WebSocketCloseError["Err_unknown"] = "unknown";
})(WebSocketCloseError = exports.WebSocketCloseError || (exports.WebSocketCloseError = {}));
function parseWSClsErr(code) {
    switch (code) {
        case 1001: {
            return WebSocketCloseError.Err_1001;
        }
        case 1002: {
            return WebSocketCloseError.Err_1002;
        }
        case 1003: {
            return WebSocketCloseError.Err_1003;
        }
        case 1006: {
            return WebSocketCloseError.Err_1006;
        }
        case 1007: {
            return WebSocketCloseError.Err_1007;
        }
        case 1008: {
            return WebSocketCloseError.Err_1008;
        }
        case 1009: {
            return WebSocketCloseError.Err_1009;
        }
        default:
            break;
    }
    return WebSocketCloseError.Err_unknown;
}
exports.parseWSClsErr = parseWSClsErr;
//# sourceMappingURL=WebSocket.js.map